import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Table } from "../../../component/table/Table";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

import { termsAndConditionsTableColumnsConfig } from "./TermsAndConditionsTableColumnDef";

import { selectTermsAndConditionsState } from "../../../store/termsAndConditions/termsAndConditionsFilterSlice";

import {
  selectTermsAndConditionsList,
  useGetTermsAndConditionsListQuery,
} from "../../../services/termsAndConditions/termsAndConditionsApiSlice";

export const TermsAndConditionsTablePage = () => {
  const navigate = useNavigate();

  const appliedFilters = useSelector(selectTermsAndConditionsState);

  const { isLoading, isFetching } =
    useGetTermsAndConditionsListQuery(appliedFilters);

  const tableData = useSelector(selectTermsAndConditionsList);
  console.log(tableData);

  const handleNavigateToDetail = useCallback(
    (id) => {
      navigate(`/terms_and_conditions/${id}`);
    },
    [navigate],
  );

  const columnDefs = useMemo(
    () => termsAndConditionsTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );

  if (isLoading) {
    return <CategoryPageSkeleton />;
  }

  return <Table data={tableData} columns={columnDefs} loading={isFetching} />;
};
